const state = reactive({
  allStories: [],
  loading: false,
  page: 1,
  perPage: 12,
  total: null,
})

export function useActivities() {
  const storyblokApi = useStoryblokApi()
  const { locale } = useI18n()

  async function fetchData(event) {
    state.loading = true
    try {
      const params = {
        version: 'published',
        per_page: state.perPage,
        page: state.page,
        language: locale.value,
        starts_with: 'sustainability/activities/',
        is_startpage: false,
        sort_by: 'content.date:desc',
      }

      const { data } = await storyblokApi.get('cdn/stories', params)

      if (data)
        state.allStories = data.stories

      const firstResponse = await storyblokApi.get('cdn/stories', params)
      state.total = firstResponse.total
    }
    catch (error) {
      return sendError(event, createError({
        statusCode: 404,
        statusMessage: 'Unauthorized client error',
      }))
    }
    finally {
      state.loading = false
    }
  }

  const formattedData = computed(() =>
    state.allStories.map(({ uuid, content, full_slug, published_at, created_at }) => ({
      uuid,
      full_slug,
      published_at,
      created_at,
      content,
    })),
  )

  return {
    ...toRefs(state),
    fetchData,
    formattedData,
  }
}
